import styled from "styled-components";

export const FieldWrapper = styled.span`
  display: flex;
  flex-wrap: wrap;
  margin: 15px 15px 0;
`;
